import {WebStorageStateStore} from "oidc-client-ts";

const tenantId:string = import.meta.env.VITE_REACT_APP_TENANTID == null ? "" : import.meta.env.VITE_REACT_APP_TENANTID;
const clientId:string = import.meta.env.VITE_REACT_APP_CLIENTID == null ? "" : import.meta.env.VITE_REACT_APP_CLIENTID;
const redirectUrl:string = import.meta.env.VITE_REACT_APP_REDIRECTURI == null ? "" : import.meta.env.VITE_REACT_APP_REDIRECTURI;

console.log("tenant id " + tenantId)
const oidcConfig = {

    authority: 'https://login.microsoftonline.com/'+tenantId+'/v2.0/', // Replace with the authority URL of your OpenID provider.
    client_id: clientId, // Replace with the client ID assigned to your application by the OpenID provider.
    redirect_uri: redirectUrl, // Replace with the callback URL where the authentication response will be received.
    response_type: 'code', // Specify the response type. 'code' indicates the authorization code flow.
    scope: 'openid profile User.Read', // Adjust the scopes as per your requirements. 'openid' and 'profile' are common scopes for authentication and user profile information.
    automaticSilentRenew: true, // Enable automatic silent renewals for refreshing tokens.
    userStore: new WebStorageStateStore({ store: window.sessionStorage }), // Specify the store for storing the authentication data.
    loadUserInfo: true // Specify whether to load the user information from the user endpoint after successful authentication.
};

export default oidcConfig;
